import React, { Component } from "react";
import ReactDOM from "react-dom";
import FormDynamic from "./forms/FormDynamic";
import FormServiceEnquiry from "./forms/FormServiceEnquiry";
import FormBookService from "./forms/FormBookService";
import FormTestDrive from "./forms/FormTestDrive";
import FormTestDriveSpecific from "./forms/FormTestDriveSpecific";
import FormMakeAnOffer from "./forms/FormMakeAnOffer";
import FormPlaceADeposit from "./forms/FormPlaceADeposit";
import FormMakeAnEnquiry from "./forms/FormMakeAnEnquiry";
import FormMakeTradeEnquiry from "./forms/FormMakeTradeEnquiry";
import FormPartsEnquiry from "./forms/FormPartsEnquiry";
import FormFinanceEnquiry from "./forms/FormFinanceEnquiry";
import FormVehicleFinanceCalculator from "./forms/FormVehicleFinanceCalculator";
import FormAutobodyEnquiry from "./forms/FormAutobodyEnquiry";
import FormVirtualAppointment from "./forms/FormVirtualAppointment";
import FormVirtualAppointmentSpecific from "./forms/FormVirtualAppointmentSpecific";
import FormMakeAFinanceEnquiryVDP from "./forms/FormMakeAFinanceEnquiryVDP";
import FormMakeAnEnquiryPassedEmail from "./forms/FormMakeAnEnquiryPassedEmail";
import SuccessPopup from "./SuccessPopup";
import SharePopup from "./SharePopup";
import ShareURLPopup from "./ShareURLPopup";
import { processMakes, processRegions } from "~/js/utils";

import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks,
} from "body-scroll-lock";

class PopupForm extends Component {
    forms = {
        "dynamic-form": FormDynamic,
        "test-drive": FormTestDrive,
        "test-drive-no-dealer": FormTestDrive,
        "test-drive-branded": FormTestDrive,
        "test-drive-offer": FormTestDrive,
        "test-drive-specific": FormTestDriveSpecific,
        "test-drive-dealer": FormTestDrive,
        "book-service": FormBookService,
        "book-service-enquiry": FormServiceEnquiry,
        "book-service-dealer": FormBookService,
        "book-service-branded": FormBookService,
        "book-service-no-dealer": FormBookService,
        "make-an-offer": FormMakeAnOffer,
        "place-a-deposit": FormPlaceADeposit,
        "make-trade-enquiry": FormMakeTradeEnquiry,
        "make-an-enquiry": FormMakeAnEnquiry,
        "make-an-enquiry-passed-email": FormMakeAnEnquiryPassedEmail,
        "make-an-enquiry-brand-page": FormMakeAnEnquiry,
        "make-an-enquiry-specific": FormMakeAnEnquiry,
        "make-an-insurance-enquiry": FormMakeAnEnquiry,
        "make-an-enquiry-offer": FormMakeAnEnquiry,
        "make-an-enquiry-dealerships": FormMakeAnEnquiry,
        "register-your-interest": FormMakeAnEnquiry,
        "make-an-enquiry-favourites": FormMakeAnEnquiry,
        "make-a-finance-enquiry-vdp": FormMakeAFinanceEnquiryVDP,
        "parts-enquiry": FormPartsEnquiry,
        "parts-enquiry-dealer": FormPartsEnquiry,
        "parts-enquiry-branded": FormPartsEnquiry,
        "parts-enquiry-no-dealer": FormPartsEnquiry,
        "autobody-enquiry": FormAutobodyEnquiry,
        "finance-enquiry": FormFinanceEnquiry,
        "finance-enquiry-offer": FormFinanceEnquiry,
        "vehicle-finance-calculator": FormVehicleFinanceCalculator,
        success: SuccessPopup,
        "share-favourites": SharePopup,
        "share-url": ShareURLPopup,
        "virtual-appointment": FormVirtualAppointment,
        "virtual-appointment-specific": FormVirtualAppointmentSpecific,
    };

    state = {
        type: null,
        brand: null,
        region: null,
        dealer: null,
        successMsg: {},
        isOpen: false,
        formId: null,
        shareTitle: null,
        passedEmail: null,
    };

    constructor(props) {
        super(props);

        this.overlayRef = React.createRef();
    }

    open = ({ type, formId, modelPrefill, shareTitle, additionalData, email, models, regions }) => {
        this.setState({regions});
        // Preselect brand / region if it's a specific form
        if (
            type === "test-drive-branded" ||
            type === "test-drive-offer" ||
            type === "book-service-branded" ||
            type === "parts-enquiry-branded" ||
            type === "virtual-appointment"
        ) {
            if (window.current_brand) {
                const brand = {
                    id: window.current_brand["id"],
                    name: window.current_brand["name"],
                    slug: window.current_brand["slug"],
                    label: window.current_brand["name"],
                    banner: window.current_brand["banner"],
                };
                this.setState({ brand });
            }
        } else if (
            type === "test-drive-dealer" ||
            type === "test-drive-offer" ||
            type === "book-service-dealer" ||
            type === "parts-enquiry-dealer"
        ) {
            const makes = processMakes(window.makes_data);

            let regions = processRegions(this.state.regions);
            const brand = makes.find(
                (make) =>
                    parseInt(make.id) === parseInt(window.current_make_seq)
            );
            const region = regions.find(
                (region) =>
                    parseInt(region.id) ===
                    parseInt(window.current_region["term_id"])
            );
            const dealer = window.current_dealer;

            if (brand) {
                brand.name = brand.label;
                brand.banner =
                    dealer.data["dealership-details"].brand[0].data.hero.bg;
                this.setState({ brand });
            }
            if (region) this.setState({ region });
            if (dealer) this.setState({ dealer });
        } else if (
            type === "make-an-enquiry-specific"  ||
            type === "make-a-finance-enquiry-vdp"


        ) {
            const dealer = window.current_dealer;

            if (dealer) this.setState({ dealer });

        } else {
            if (window.current_brand) {
                const brand = {
                    id: window.current_brand["id"],
                    name: window.current_brand["name"],
                    slug: window.current_brand["slug"],
                    label: window.current_brand["name"],
                    banner: window.current_brand["banner"],
                };
                if(brand.id != ""){
                    this.setState({ brand });

                }
            }else{
                this.setState({ brand: null, region: null, dealer: null });

            }
            this.setState({ region: null, dealer: null });
            if (email) this.setState( {passedEmail: email});
        }

        if (!modelPrefill) {
            // modelPrefill = " " // hack
        }
        if(type === "make-trade-enquiry"){
            this.setState({
                models
            })
        }
        this.setState({
            isOpen: true,
            type,
            formId,
            modelPrefill,
            shareTitle,
            additionalData,
        });


        disableBodyScroll(this.overlayRef.current);
    };

    close = () => {
        this.setState({ isOpen: false });
        enableBodyScroll(this.overlayRef.current);

        if (typeof jQuery !== "undefined" && typeof formId !== "undefined")
            jQuery(`#gform_${formId}`).off();
    };

    componentDidMount() {
        window.addEventListener("keydown", this.handleDown);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleDown);
    }

    handleDown = (e) => {
        // On Esc press
        if (e.keyCode == 27) {
            this.close();
        }
    };

    // handleOverlay = (e) => {
    //     // If clicked on content part
    //     // Don't close
    //     let target = up(e.target, function(parent) {
    //         return parent ? parent.getAttribute('popup-form') === 'content' : false;
    //     });

    //     if (target === null) {
    //         this.close();
    //     }
    // };

    showSuccessPopup = ({ title, text }) => {
        this.setState({
            isOpen: true,
            type: "success",
            successMsg: { title, text },
        });
    };

    render() {
        const {
            type,
            isOpen,
            successMsg,
            brand,
            region,
            passedEmail,
            dealer,
            formId,
            modelPrefill,
            shareTitle,
            additionalData,
            regions,
        } = this.state;
        let Component = () => null;

        let props = {
            close: this.close,
            showSuccessPopup: this.showSuccessPopup,
            successMsg,
            type,
            passedEmail,
            brand,
            region,
            dealer,
            modelPrefill,
            shareTitle,
            additionalData,
            regions
        };

        if (type) {
            Component = this.forms[type];
        }

        if (type == "dynamic-form" || type == "place-a-deposit") {
            props.formId = formId;
        }
        if(type == 'make-trade-enquiry'){
            props.models = this.state.models;
        }

        return (
            <div
                className={`popup-form__overlay ${
                    isOpen ? "is-popup-open" : ""
                }`}
                ref={this.overlayRef}
            >
                <div className={`popup-form__wrap`}>
                    {isOpen || type != "place-a-deposit" ? (
                        <Component {...props} />
                    ) : null}

                    <div
                        className={`popup-form__bg`}
                        onClick={this.close}
                    ></div>
                </div>
            </div>
        );
    }
}

export default function(el, props) {
    return ReactDOM.render(<PopupForm {...props} />, el);
}
